import React from "react";
import "../style/loader.css";

function Spinner(props) {
  return (
    <div className="spinner-container">
      <div
        className="loader"
        style={{
          // Priority: Prop color -> default image blue
          backgroundColor: "#0056b3", 
          ...props.style,
        }}
      ></div>
    </div>
  );
}

export default Spinner;